import { Dimensions, ScrollView, StyleSheet } from 'react-native';

import { Text, View } from '../components/Themed';
import Notireg from '../components/Notireg';
import Loader from '../components/Loader';

import * as React from 'react';
import Update from '../components/Update';
import Dashboard from '../components/Dashboard';
import { Button, FAB, useTheme } from 'react-native-paper';
import { SafeAreaProvider, SafeAreaView } from 'react-native-safe-area-context';
import Snack from './Snack';
import { useSelector } from 'react-redux';
import { collection, doc, getFirestore, setDoc } from 'firebase/firestore';
import Global from '../constants/global';

export default function Index({ navigation }) {
  const { colors } = useTheme()
  return (
    <SafeAreaView style={{ flex: 1 }}>
      <ScrollView contentContainerStyle={{ backgroundColor: colors.background }} style={{ flex: 1, height: Dimensions.get("screen").height }}>
        <Loader />
        {/* <ToPerson /> */}
        <Notireg />
        <Dashboard navigation={navigation} />
        <Update />
      </ScrollView>
      <Snack />

    </SafeAreaView>);
}
// let counterr = 0
// const ToPerson = () => {
//   const users = useSelector(s => s.list.Users)
//   const [pers, setPersons] = React.useState([])
//   async function save(p) {
//     const db = getFirestore()
//     const ref = doc(collection(db, Global.STUDENTS))
//     p.id = ref.id
//     setDoc(ref, p).then(() => {
//       //console.log(counterr++)
//     })
//   }
//   return <View>
//     <Button onPress={() => {
//       //console.log(users)
//       const per = users.filter(f => f?.type == undefined && f?.class2023?.classId)
//       const newP: [] = []
//       per.map((pp, i) => {
//         const p = { ...pp }
//         delete p.marks
//         delete p.class
//         delete p.gr
//         delete p.result
//         delete p.roll
//         delete p.stamp
//         delete p.createdOn
//         delete p.createdByName
//         delete p.createdBy
//         delete p.classId
//         save(p)
//         // newP.push(p)
//       })

//       // //console.log(JSON.stringify(per))
//       // //console.log(JSON.stringify(newP))
//       // //console.log(newP)
//       // setPersons(newP)
//     }} style={{ padding: 15 }}>Perge {users.length} =  {pers.length}</Button>
//     {/* })} */}
//   </View>
// }